export const RIDE_ADMIN_DETAIL_OPEN = 'RIDE_ADMIN_DETAIL_OPEN';
export const RIDE_ADMIN_DETAIL_CLOSE = 'RIDE_ADMIN_DETAIL_CLOSE';

export const detailOpen = options => ({ type: RIDE_ADMIN_DETAIL_OPEN, payload: options });
export const detailClose = () => ({ type: RIDE_ADMIN_DETAIL_CLOSE });
